import { render, staticRenderFns } from "./noActive.vue?vue&type=template&id=118d4b8c&scoped=true"
import script from "./noActive.vue?vue&type=script&lang=js"
export * from "./noActive.vue?vue&type=script&lang=js"
import style0 from "./noActive.vue?vue&type=style&index=0&id=118d4b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118d4b8c",
  null
  
)

export default component.exports